import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function Star(props) {
  const {
    fillId,
    changeRating,
    hoverOverStar,
    unHoverOverStar,
    isStarred,
    isPartiallyFullStar,
    isHovered,
    hoverMode,
    isCurrentHoveredStar,
    isFirstStar,
    isLastStar,
    starDimension,
    starSpacing,
    starHoverColor,
    starRatedColor,
    starEmptyColor,
    gradientPathName,
    ignoreInlineStyles,
    svgIconPath,
    svgIconViewBox,
  } = props;

  // Build styles only when inline styles are enabled
  const starContainerStyle = ignoreInlineStyles
    ? undefined
    : (() => {
        const s = {
          position: 'relative',
          display: 'inline-block',
          verticalAlign: 'middle',
        };
        if (changeRating) s.cursor = 'pointer';
        if (!isFirstStar) s.paddingLeft = starSpacing;
        if (!isLastStar) s.paddingRight = starSpacing;
        return s;
      })();

  const starSvgStyle = ignoreInlineStyles
    ? undefined
    : (() => {
        const s = {
          width: starDimension,
          height: starDimension,
          transition: 'transform .2s ease-in-out',
        };
        if (isCurrentHoveredStar) s.transform = 'scale(1.1)';
        return s;
      })();

  const pathStyle = ignoreInlineStyles
    ? undefined
    : (() => {
        let fill;
        if (hoverMode) {
          fill = isHovered ? starHoverColor : starEmptyColor;
        } else if (isPartiallyFullStar) {
          fill = `url('${gradientPathName}#${fillId}')`;
        } else if (isStarred) {
          fill = starRatedColor;
        } else {
          fill = starEmptyColor;
        }
        return { fill, transition: 'fill .2s ease-in-out' };
      })();

  const starClasses = ignoreInlineStyles
    ? ''
    : classNames({
        'widget-svg': true,
        'widget-selected': isStarred,
        'multi-widget-selected': isPartiallyFullStar,
        hovered: isHovered,
        'current-hovered': isCurrentHoveredStar,
      });

  return (
    <div
      className="star-container"
      style={starContainerStyle}
      onMouseEnter={hoverOverStar}
      onMouseLeave={unHoverOverStar}
      onClick={changeRating}
    >
      <svg viewBox={svgIconViewBox} className={starClasses} style={starSvgStyle}>
        <path className="star" style={pathStyle} d={svgIconPath} />
      </svg>
    </div>
  );
}

Star.propTypes = {
  fillId: PropTypes.string.isRequired,
  changeRating: PropTypes.func,
  hoverOverStar: PropTypes.func,
  unHoverOverStar: PropTypes.func,
  isStarred: PropTypes.bool.isRequired,
  isPartiallyFullStar: PropTypes.bool.isRequired,
  isHovered: PropTypes.bool.isRequired,
  hoverMode: PropTypes.bool.isRequired,
  isCurrentHoveredStar: PropTypes.bool.isRequired,
  isFirstStar: PropTypes.bool.isRequired,
  isLastStar: PropTypes.bool.isRequired,
  starDimension: PropTypes.string.isRequired,
  starSpacing: PropTypes.string.isRequired,
  starHoverColor: PropTypes.string.isRequired,
  starRatedColor: PropTypes.string.isRequired,
  starEmptyColor: PropTypes.string.isRequired,
  gradientPathName: PropTypes.string.isRequired,
  ignoreInlineStyles: PropTypes.bool.isRequired,
  svgIconPath: PropTypes.string.isRequired,
  svgIconViewBox: PropTypes.string.isRequired,
};

export default Star;
